module.exports = __webpack_public_path__ + "img/Fabella.6b46d541.png";